/*
 * @Author: dinglizu
 * @Date: 2022-02-09 15:09:35
 * @LastEditTime: 2023-02-07 11:12:56
 * @LastEditors: dinglizu
 * @Description: 
 */
import Vue from 'vue'
import Router from 'vue-router'
import { lib } from '@/assets/js/lib'
import store from './../vuex/store'
import tpo from "./toefl/tpo";
import gre from "./gre/gre";
import dictation from "./dictation/dictation";
import manage from "./manage/manage"
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/login'], resolve),
      meta: {
        title: '知学君',
      }
    },
    {
      path: '/',
      name: 'PageView',
      meta: {
        requireAuth: true,
      },
      redirect: "/toefl",
      component: resolve => require(['@/view/pageView'], resolve),
      children: [{
        path: '/toefl',
        name: 'ToeflRouter',
        component: resolve => require(['@/view/toefl/Index'], resolve),
        redirect: "/toefl/index",
        meta: {
          title: '托福',
          requireAuth: true,
        },
        children: tpo
      },
      {
        path: '/gre',
        name: 'GRE首页',
        component: resolve => require(['@/view/gre/Index'], resolve),
        redirect: "/gre/index",
        meta: {
          requireAuth: true,
        },
        children: gre
      },
      {
        path: '/dictation',
        name: '听写跟读',
        meta: {
          requireAuth: true,
        },
        redirect: "/dictation/home",
        component: resolve => require(['@/view/dictation/Index'], resolve),
        title: '听写跟读',
        children: dictation
      }
      ]
    },

    {
      path: '/manage',
      name: 'manageIndex',
      meta: {
        requireAuth: true,
      },
      redirect: "/manage/profile/index",  
      component: resolve => require(['@/view/manage/PageView'], resolve),
      title: '机构管理',
      children: manage
    },
    {
      path: '/vip',
      name: 'vipPageView',
      redirect: "/vip/index",
      meta: {
        requireAuth: true,
      },
      
      component: resolve => require(['@/view/vip/vipPageView'], resolve),
      children: [
        {
          path: '/vip/index',
          name: 'VIP',
          component: resolve => require(['@/view/vip/index/index'], resolve),
          meta: {
            title: '知学君',
          }
        },
        {
          path: '/vip/customerService',
          name: '联系客服',
          component: resolve => require(['@/view/vip/customerService/index'], resolve),
          meta: {
            title: '知学君',
          }
        },
        {
          path: '/vip/purchase',
          name: '购买',
          component: resolve => require(['@/view/vip/purchase/index'], resolve),
          meta: {
            title: '知学君',
          }
        },
      ]
    }

  ]
})
router.beforeEach((to, from, next) => {
  /**
   * 未登录则跳转到登录页
   * 未登录跳转到登录页,也可以通过axios的响应拦截器去实现,但是会先在当前页面渲染一下,再跳转到登录页,会有个闪动的现象
   * 这里通过路由守卫的方式,不会在当前页闪现一下,但是需要在每个路由组件添加一个是否需要登录的标识位,如本项目中的requireAuth字段
   */
  router.$history = from;
  if (to.matched.some((auth) => auth.meta.requireAuth)) {
    let token = store.state.token;
    if (token) {
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js